import React from 'react';

import Reveal, { SectionTitle } from './Reveal';
import { EDUCATION } from '../data/site';

export default function NewEdu() {
  return (
    <section className="section" id="education">
      <SectionTitle eyebrow="Academics" title="Education" />

      <div className="tl">
        {EDUCATION.map((e, i) => (
          <Reveal key={`${e.school}-${e.period}`} delay={i * 0.07} className="tl-item">
            <article className="glass tl-card">
              <div className="tl-head">
                <h3 className="tl-company">{e.school}</h3>
                <span className="tl-period">{e.period}</span>
              </div>

              <div className="tl-role">{e.degree}</div>
              {e.place && <div className="tl-place">{e.place}</div>}

              <span className="edu-score">{e.score}</span>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
